<template>
  <div class="cover-container">
    <div :class="{
      'page': true,
      'page-1': true,
      'fade-in': coverPage1Flag,
      }"
    >
      <div class="page-1-top">
        <div class="title-wrapper">
          <h3>{{page1DynamicDigit}}</h3>
        </div>
      </div>
      <div class="page-1-bottom">
        <div class="sub-title-wrapper">
          <h4>1999年的921大地震</h4>
        </div>
        <div class="cover-abstract">
          <div class="dynamic-digit">2415條</div>
          <div class="dash"><hr></div>
          <div class="dynamic-digit-description">帶走2415條人命</div>
        </div>
        <div class="cover-abstract">
          <div class="dynamic-digit">11000人</div>
          <div class="dash"><hr></div>
          <div class="dynamic-digit-description">11000人受傷</div>
        </div>
        <div class="cover-abstract">
          <div class="dynamic-digit">10萬</div>
          <div class="dash"><hr></div>
          <div class="dynamic-digit-description">震倒逾10萬棟房屋</div>
        </div>
      </div>
    </div>
    <div :class="{'page page-2': true, 'fade-in': page2FadeInFlag}">
      <CoverMap
        :coverPage1Flag="coverPage1Flag"
        :coverPage2Flag="coverPage2Flag"
      ></CoverMap>
      <div class="page-2-top">
        <div class="title-wrapper">
          <h3>{{page2DynamicDigit}}</h3>
        </div>
      </div>
      <div class="page-2-bottom">
        <div class="sub-title-wrapper">
          <p>如果921大地震<span><br></span>發生在2019年...</p>
          <p>根據國震中心推估，仍會有...</p>
        </div>
        <div class="cover-abstract-container">
          <div class="cover-abstract">
            <div class="cover-abstract-digit">{{page2DynamicDigitContent.current_1}}</div>
            <div class="cover-abstract-text">間房子倒塌</div>
          </div>
          <div class="cover-abstract">
            <div class="cover-abstract-digit">{{page2DynamicDigitContent.current_2}}</div>
            <div class="cover-abstract-text">人傷亡</div>
          </div>
          <div class="cover-abstract">
            <div class="cover-abstract-text">人數是<br>南台大地震的</div>
            <div class="cover-abstract-digit">{{page2DynamicDigitContent.current_3}}<span class="cover-abstract-text">倍</span></div>
          </div>
          <div class="cover-abstract">
            <div class="cover-abstract-text">人數是<br>花蓮地震的</div>
            <div class="cover-abstract-digit">{{page2DynamicDigitContent.current_4}}<span class="cover-abstract-text">倍</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-down-arrow-wrapper">
      <ScrollDownArrow></ScrollDownArrow>
    </div>
  </div>
</template>

<script>
import CoverMap from './CoverMap.vue';
import ScrollDownArrow from '../../../../general_components/ScrollDownArrow.vue';

export default {
  name: 'Cover',
  components: {
    CoverMap,
    ScrollDownArrow,
  },
  props: {
    coverPage1Flag: {
      type: Boolean,
      required: true,
    },
    coverPage2Flag: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      page1DynamicDigit: 1900,
      page2DynamicDigit: 1999,
      page2DynamicDigitContent: {
        current_1: 32700,
        end_1: 32775,
        current_2: 3500,
        end_2: 3564,
        current_3: 0,
        end_3: 30,
        current_4: 120,
        end_4: 200,
      },
      page2FadeInFlag: false,
    };
  },
  watch: {
    coverPage1Flag: {
      handler(flag) {
        this.page1DynamicDigit = 1900;
        const digitTimer = setInterval(() => {
          if (this.page1DynamicDigit < 1999) {
            this.page1DynamicDigit++;
          }
          if (this.page1DynamicDigit >= 1999) {
            clearTimer();
          }
        }, 10);
        function clearTimer() {
          clearInterval(digitTimer);
        }
      },
      deep: true,
    },
    coverPage2Flag: {
      handler(flag) {
        this.page2DynamicDigit = 1999;
        const digitTimer = setInterval(() => {
          if (this.page2DynamicDigit < 2019) {
            this.page2DynamicDigit++;
          }
          if (this.page2DynamicDigit >= 2019) {
            clearTimer();
          }
        }, 30);
        function clearTimer() {
          clearInterval(digitTimer);
        }
        this.page2DynamicDigitContent.current_1 = 32700;
        const digitTimerContent_1 = setInterval(() => {
          if (this.page2DynamicDigitContent.current_1 < this.page2DynamicDigitContent.end_1) {
            this.page2DynamicDigitContent.current_1++;
          }
          if (this.page2DynamicDigitContent.current_1 >= this.page2DynamicDigitContent.end_1) {
            clearTimerContent_1();
          }
        }, 30);
        function clearTimerContent_1() {
          clearInterval(digitTimerContent_1);
        }
        this.page2DynamicDigitContent.current_2 = 3500;
        const digitTimerContent_2 = setInterval(() => {
          if (this.page2DynamicDigitContent.current_2 < this.page2DynamicDigitContent.end_2) {
            this.page2DynamicDigitContent.current_2++;
          }
          if (this.page2DynamicDigitContent.current_2 >= this.page2DynamicDigitContent.end_2) {
            clearTimerContent_2();
          }
        }, 30);
        function clearTimerContent_2() {
          clearInterval(digitTimerContent_2);
        }
        this.page2DynamicDigitContent.current_3 = 0;
        const digitTimerContent_3 = setInterval(() => {
          if (this.page2DynamicDigitContent.current_3 < this.page2DynamicDigitContent.end_3) {
            this.page2DynamicDigitContent.current_3++;
          }
          if (this.page2DynamicDigitContent.current_3 >= this.page2DynamicDigitContent.end_3) {
            clearTimerContent_3();
          }
        }, 30);
        function clearTimerContent_3() {
          clearInterval(digitTimerContent_3);
        }
        this.page2DynamicDigitContent.current_4 = 120;
        const digitTimerContent_4 = setInterval(() => {
          if (this.page2DynamicDigitContent.current_4 < this.page2DynamicDigitContent.end_4) {
            this.page2DynamicDigitContent.current_4++;
          }
          if (this.page2DynamicDigitContent.current_4 >= this.page2DynamicDigitContent.end_4) {
            clearTimerContent_4();
          }
        }, 30);
        function clearTimerContent_4() {
          clearInterval(digitTimerContent_4);
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.page2FadeInFlag = true;
    }, 300);
  },
};
</script>

<style lang="scss" scoped>
  .cover-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    .page {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 70px 20px;
      opacity: 0;
      transition: opacity .666s ease-in-out;
      p, h1, h2, h3, h4 {
        color: #ffffff;
      }
      p {
        margin: 0;
      }
      .title-wrapper {
        h3 {
          font-size: 2.2rem;
          @media only screen and (max-width: 375px) {
            font-size: 1.9rem;
          }
        }
      }
    }
    .fade-in {
      opacity: 1;
    }
    .page-1 {
      z-index: 10;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-image: url('../../assets/images/cover/921_cover_bg_mob.jpg');
      background-size: cover;
      @media only screen and (min-width: 768px) and (max-width: 1024px) {
        background-image: url('../../assets/images/cover/921_cover_bg_pad.jpg');
      }
      @media only screen and (min-width: 1025px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-image: url('../../assets/images/cover/921_cover_bg_pc.jpg');
      }
      .page-1-bottom {
        @media only screen and (min-width: 1025px) {
          padding-right: 50%;
        }
        .sub-title-wrapper {
          height: 40vh;
          display: flex;
          justify-content: center;
          align-items: center;
          @media only screen and (max-width: 320px) {
            margin-top: 8%;
            margin-bottom: 7%;
          }
          @media only screen and (min-width: 321px) and (max-width: 375px) {
            margin-top: 17%;
            margin-bottom: 1%;
          }
          @media only screen and (min-width: 376px) and (max-width: 767px) {
            margin-top: 18%;
          }

          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin-top: 15%;
            margin-bottom: 10%;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1280px) {
            height: auto;
            margin-top: 20%;
            margin-bottom: 20%;
          }
          @media only screen and (min-width: 1281px) {
            height: auto;
            margin-top: 10%;
            margin-bottom: 10%;
          }
        }
        .cover-abstract {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          color: #ffffff;
          margin: 5px 0;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            padding-left: 24%;
          }
          @media only screen and (min-width: 1025px) {
            justify-content: center;
            align-items: center;
            margin: 10px 0;
          }
          .dynamic-digit {
            font-size: 40px;
            font-size: 2.5rem;
            @media only screen and (max-width: 375px) {
              font-size: 1.9rem;
            }
          }
          .dash {
            flex-grow: 1;
            padding: 0 5px;
          }
          .dynamic-digit-description {
            width: 50%;
            white-space:nowrap;
            @media only screen and (min-width: 1025px) {
              width: 40%;
            }
          }
        }
      }
    }
    .page-2 {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-color: #162236;
      color: #ffffff;
      @media only screen and (min-width: 1025px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      .page-2-top {
        position: relative;
      }
      .page-2-bottom {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 15%;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
         padding: 0 25%;
        }
        @media only screen and (min-width: 1025px) {
          padding: 0 50% 0 0;
        }
        .sub-title-wrapper {
          width: 100%;
          margin: 5% 0;
        }
        .cover-abstract-container {
          width: 100%;
          .cover-abstract {
            position: relative;
            float: left;
            width: 50%;
            &:nth-child(odd) {
              padding: 10% 5% 10% 0;
              @media only screen and (min-width: 768px) and (max-width: 1024px) {
                padding: 10% 15% 10% 0;
              }
              @media only screen and (min-width: 1025px) {
                padding: 5% 1% 5% 0;
              }
            }
            &:nth-child(even) {
              padding: 10% 0 10% 5%;
              @media only screen and (min-width: 768px) and (max-width: 1024px) {
                padding: 10% 0 10% 15%;
              }
              @media only screen and (min-width: 1025px) {
                padding: 5% 0 5% 1%;
              }
            }
            .cover-abstract-digit {
              font-size: 2rem;
              font-weight: bold;
            }
            .cover-abstract-text {
              font-weight: normal;
            }
          }
        }
      }
    }
    .page-3 {
      z-index: 30;
      background-color: #0e141e;
      padding-top: 100px;
    }
    .scroll-down-arrow-wrapper {
      position: absolute;
      z-index: 50;
      left: 0;
      bottom: 10%;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
</style>
